import React from "react";
import PropTypes from "prop-types";

/**
 * Contains a failure to one block.
 *
 * The narrative around a block is usually a complete answer on its own, so a
 * chart that cannot draw must never cost the words. Each block gets its own
 * boundary rather than one around the message.
 */
class BlockBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.warn(`[Lou] ${this.props.kind} block failed to render`, error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <p className="lou-block__failed">
        This {this.props.kind.replace(/-/g, " ")} could not be displayed.
      </p>
    );
  }
}

BlockBoundary.propTypes = {
  kind: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default BlockBoundary;
